// Height of the main app's fixed top bar. App.tsx renders a spacer of this
// height under it, so full-height pages must subtract it to avoid making the
// document scroll.
export const MAIN_APP_BAR_HEIGHT_PX = 72;
